import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Field, FieldTypes, Inscription, RadioButton, useResponsive } from '@common-fe/common-fe';

import { centeredFieldStyles } from '@/modules/user/components/SignUp/signUp.constants';

export default () => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const fields = useMemo<Field[]>(
    () => [
      {
        name: 'verification',
        type: FieldTypes.Node,
        showRequireIcon: isMobile,
        label: t('Verification'),
        value: (
          <Box width="320px">
            <Box direction="row">
              {isMobile && (
                <RadioButton
                  name="email"
                  checked
                  disabled
                  label={<Inscription weight={700}>{t('Email')}</Inscription>}
                />
              )}
            </Box>
            <Inscription margin={{ top: 'spacing8' }}>
              {t(
                'We’ll send you an email to the email address listed. Just click verify and you’ll be all set to Sign in.'
              )}
            </Inscription>
          </Box>
        ),
        ...(isMobile ? {} : centeredFieldStyles),
      },
    ],
    [t, isMobile]
  );
  return fields;
};
